import { useCallback, useEffect, useState } from 'react';
import { newsService } from '../services/news';
import { ExternalNewsFeed } from '../types/news';

export function useExternalNews() {
  const [feed, setFeed] = useState<ExternalNewsFeed | null>(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await newsService.getLatest();
      setFeed(data);
    } catch {
      setError('failed');
      setFeed(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(async () => {
    setRefreshing(true);
    setError(null);
    try {
      const data = await newsService.refresh();
      setFeed(data);
    } catch {
      setError('failed');
    } finally {
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { feed, loading, refreshing, error, reload, refresh };
}
